import React from 'react';
import Home from '../Components/Home';

const HomePage = () => (
  <div>
    <Home />
  </div>
);

export default HomePage;
